import type { TransactionBuilder } from '@/contexts/Transaction/TransactionV2.context'

import type { TrackTransactionParams } from './tracker'

export const getSdkTracking = (
  transaction: TransactionBuilder
): Pick<TrackTransactionParams, 'sdkAction'> => {
  try {
    return { sdkAction: transaction.buildTx().action.type }
  } catch {
    return {}
  }
}
